import axios from "axios";
import { isArray, isEmpty, map } from "lodash";
import normalize from "Utils/normalizer";
import useSession from "Hooks/session.hook";
import errorHandler from "Utils/error-handler";
import { getAccessToken } from "Helpers/session";
import { DefaultFilter } from "../types/common.types";

const url = `${process.env.API_URL}/${process.env.API_VER}`;

interface Filters extends DefaultFilter {
  orFields?: string;
  tempDelete?: boolean;
}

interface Pagination {
  offset: number;
  limit: number;
}

export const createOrderSetting = async (inputData: any) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/order_processing_setting/create`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: normalize.model.order_setting(inputData),
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await createOrderSetting(inputData);
      const { value, code, message, stack, info } = await errorHandler.response(error, {
        callback,
      });
      return { error: { value, code, message, stack, info } };
    } else {
      console.log(err.message);
      return { error: { message: err.message, info: err?.info } };
    }
  }
};

export const updateOrderSetting = async (inputData: any) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/order_processing_setting/update`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: normalize.model.order_setting(inputData),
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    return response;
  } catch (err: any) {
    const { error } = err.response?.data || {};
    console.log(err.response);

    if (!isEmpty(error)) {
      const callback = async () => await updateOrderSetting(inputData);
      const { value, code, message, stack, info } = await errorHandler.response(error, {
        callback,
      });
      return { error: { value, code, message, stack, info } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchOrderSettingList = async (
  // filters: Filters,
  filters: any,
  pagination?: Pagination
) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/order_processing_setting/list`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: filters,
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    if (isArray(response.data.settingList)) {
      return map(response.data.settingList, (settingObj) => {
        return normalize.response.order_setting(settingObj);
      });
    }

    /* let inactiveSettingList = map(response.data.settingList.inactiveSetting, settingObj => {
           return normalize.response.order_setting(settingObj);
         })*/

    return map(response.data.settingList.activeSetting, (settingObj) => {
      return normalize.response.order_setting(
        settingObj,
        response.data.settingList.inactiveSetting
      );
    });
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchOrderSettingList(filters);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};

export const fetchOrderSetting = async (orderSettingID: any) => {
  const accessToken = getAccessToken();
  const { org, profile } = useSession();

  try {
    const response = await axios({
      method: "POST",
      url: `${url}/order_processing_setting/fetch`,
      data: {
        admin: {
          orgID: org._id,
          profileID: profile._id,
        },
        data: {
          settingID: orderSettingID,
        },
      },
      headers: { Authorization: `Bearer ${accessToken}` },
    });

    return normalize.response.order_setting(response.data.settingList);
  } catch (err: any) {
    const { error } = err.response?.data || {};

    if (!isEmpty(error)) {
      const callback = async () => await fetchOrderSetting(orderSettingID);
      const { value, code, message, stack } = await errorHandler.response(error, { callback });
      return { error: { value, code, message, stack } };
    } else {
      console.log(err.message);
      return { error: { message: err.message } };
    }
  }
};
